module.exports = __webpack_public_path__ + "img/volume_on.50585ab6.png";